const initializeLedvibeCatalogs = (root = document) => {
  root.querySelectorAll('[data-lv-catalog]').forEach((catalog) => {
    if (catalog.dataset.lvCatalogInitialized === 'true') return;
    catalog.dataset.lvCatalogInitialized = 'true';

    const filters = Array.from(catalog.querySelectorAll('[data-lv-filter]'));
    const products = Array.from(catalog.querySelectorAll('[data-lv-product]'));
    const status = catalog.querySelector('[data-lv-filter-status]');
    const grid = catalog.querySelector('.lv-catalog-preview__grid');
    const dialog = catalog.querySelector('[data-lv-product-preview-dialog]');
    let lastPreviewTrigger = null;

    const applyFilter = (activeFilter) => {
      const target = activeFilter.dataset.lvFilter;
      let visibleCount = 0;

      filters.forEach((button) => {
        const isActive = button === activeFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      products.forEach((product) => {
        const groups = (product.dataset.groups || '').split(',');
        const isVisible = target === 'all' || groups.includes(target);
        product.hidden = !isVisible;

        if (isVisible) {
          product.style.setProperty('--lv-card-order', visibleCount);
          visibleCount += 1;
        }
      });

      if (status) {
        const filterLabel = activeFilter.textContent.trim().replace(/^All\s+\d+$/i, 'all');
        status.textContent = target === 'all'
          ? `Showing all ${visibleCount} products`
          : `Showing ${visibleCount} ${filterLabel.toLowerCase()} products`;
      }

      if (grid) {
        grid.classList.remove('is-filtered');
        window.requestAnimationFrame(() => grid.classList.add('is-filtered'));
      }
    };

    filters.forEach((filter, index) => {
      filter.addEventListener('click', () => applyFilter(filter));
      filter.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;

        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + filters.length) % filters.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % filters.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = filters.length - 1;

        filters[nextIndex].focus();
        applyFilter(filters[nextIndex]);
      });
    });

    if (dialog) {
      const media = dialog.querySelector('[data-lv-product-preview-media]');
      const meta = dialog.querySelector('[data-lv-product-preview-meta]');
      const title = dialog.querySelector('[data-lv-product-preview-title]');
      const price = dialog.querySelector('[data-lv-product-preview-price]');
      const comparePrice = dialog.querySelector('[data-lv-product-preview-compare]');
      const closeButton = dialog.querySelector('[data-lv-product-preview-close]');

      catalog.querySelectorAll('[data-lv-product-preview-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const product = trigger.closest('[data-lv-product]');
          const sourceImage = product?.querySelector('.lv-catalog-preview__media img');

          if (!product) return;
          lastPreviewTrigger = trigger;

          media.replaceChildren();
          if (sourceImage) {
            const previewImage = sourceImage.cloneNode();
            previewImage.loading = 'eager';
            media.appendChild(previewImage);
          } else {
            const fallback = document.createElement('span');
            fallback.textContent = product.dataset.productCode || 'LEDVIBESHOP';
            media.appendChild(fallback);
          }

          meta.textContent = `${product.dataset.productCode} · ${product.dataset.productVariants} SKU${product.dataset.productVariants === '1' ? '' : 's'}`;
          title.textContent = product.dataset.productTitle;
          price.textContent = `From $${product.dataset.productPrice}`;
          comparePrice.textContent = `$${product.dataset.productComparePrice}`;
          dialog.showModal();
        });
      });

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => lastPreviewTrigger?.focus());
    }
  });
};

initializeLedvibeCatalogs();
document.addEventListener('shopify:section:load', (event) => initializeLedvibeCatalogs(event.target));
